module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_iterators.js
// module id = /bQp
// module chunks = 2